export default __webpack_public_path__ + "static/media/dashboard_check_dark.0512b48f.svg";